// extracted by mini-css-extract-plugin
export default {"markdownContainer":"Markdown_markdownContainer__a03W3"};